'use client';

import { cn, TooltipPositionsEnum, TooltipProps } from 'types';

const positionStyles = {
  TOP: cn('bottom-8 after:bottom-[-0.4rem] after:right-[calc(50%-0.5rem)] after:rotate-[225deg]'),
  BOTTOM: cn('top-8 after:top-[-0.4rem] after:right-[calc(50%-0.5rem)] after:rotate-45'),
  LEFT: cn('-left-8 top-3 after:right-[-6px] after:top-[0.813rem] after:rotate-[135deg]'),
  RIGHT: cn('-right-8 top-3 after:left-[-6px] after:top-[0.813rem] after:rotate-[-45deg]'),
};

const mercedesOverrides = {
  TOP: cn('after:w-2 after:h-2 after:bottom-[-4px]'),
  BOTTOM: cn('after:w-2 after:h-2 after:top-[-5px]'),
  LEFT: '',
  RIGHT: '',
};

export function Tooltip({
  children,
  content,
  tooltipPosition = TooltipPositionsEnum.TOP,
  site = 'default',
  small = false,
  ariaLabel = false,
  enabledCondition = true,
  className,
  tooltipClassName = '',
}: TooltipProps) {
  return (
    <span className={cn('relative flex justify-center group z-1', ariaLabel && 'arialLabel', className)}>
      {children}

      {enabledCondition && (
        <span
          className={cn(
            // Base tooltip
            'absolute hidden group-hover:flex',
            'opacity-100 font-light',
            'w-max max-w-75',
            small ? 'px-2 py-0.5' : 'px-5 py-2.5',
            'text-[12pt]',
            'rounded-[0.4rem]',
            'bg-black text-white',

            // Arrow base
            "after:content-[''] after:absolute",
            'after:w-3 after:h-3',
            'after:bg-black',

            positionStyles[tooltipPosition],
            site === 'mercedes' && mercedesOverrides[tooltipPosition],
            tooltipClassName
          )}
        >
          {content}
        </span>
      )}
    </span>
  );
}
